// this file should be imported at the top of each entry file to the app

// since the CDN is different in QA and Prod, we don't know the path at compile time
// so we can't set it in the webpack config, instead, leave `publicPath` blank and
// set this global variable so that lazy loading will call to correct CDN url in non-dev envs
// https://webpack.js.org/guides/public-path/#on-the-fly
// https://webpack.js.org/configuration/output/#outputpublicpath
// @ts-ignore
__webpack_public_path__ = window.__initialState.publicStaticsUrl
